import React from 'react';

const IconFile = () => {
	return <em className="fa-solid fa-file-lines text-blue-2"></em>;
};

export default IconFile;